<form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>

  <ng-container *ngFor="let section of schema.sections">

    <!-- título de sección (opcional) -->
     <!-- se oculta temporalmente para dar más protagonismo a los campos mismos, pero se puede reactivar fácilmente si se desea mostrar los títulos de sección. -->
    <!-- <div *ngIf="section.title && schema.layout?.showSectionTitles !== false"
         class="af-section-header">
      <h3>{{ section.title }}</h3>
      <p *ngIf="section.description">{{ section.description }}</p>
    </div> -->

    <!-- grilla de campos -->
    <div
      class="af-fields-grid"
      [style.--af-cols]="section.columns ?? schema.layout?.columns ?? 1">

      <ng-container *ngFor="let field of section.fields">

        <!-- usar condición reactiva en lugar de estática -->
        <div
          class="af-field-cell"
          [style.--af-span]="field.colSpan ?? 1"
          *ngIf="!isFieldHidden(field.id)">

          <app-dynamic-field
            [field]="field"
            [form]="form">
          </app-dynamic-field>

        </div>

      </ng-container>
    </div>

  </ng-container>

  <!-- acciones -->
  <div class="af-actions"
    *ngIf="schema.mode !== 'readonly'"
    [style.justify-content]="schema.theme?.submitAlign === 'left'   ? 'flex-start'
                            : schema.theme?.submitAlign === 'center' ? 'center'
                            : schema.theme?.submitAlign === 'full'   ? 'stretch'
                            : 'flex-end'">

    <button
      type="button"
      class="af-btn-cancel"
      *ngIf="schema.cancelLabel"
      (click)="onCancel()">
      {{ schema.cancelLabel }}
    </button>

    <button
      type="submit"
      class="af-btn-submit"
      [style.background]="schema.theme?.submitBtnColor || null"
      [style.color]="schema.theme?.submitBtnTextColor || null"
      [style.width]="schema.theme?.submitAlign === 'full' ? '100%' : null"
      [disabled]="form.invalid">
      {{ schema.submitLabel ?? 'Guardar' }}
    </button>

  </div>

</form>